import fetch from "auth/FetchInterceptor";

const Barcode = {};

Barcode.getBarcodeData = function (payload) {
  return fetch({
    url: "/barcode/data",
    method: "post",
    data: payload
  });
};

Barcode.markPrintedAt = function (payload) {
  return fetch({
    url: "/barcode/printed-at",
    method: "post",
    data: payload
  });
};

export default Barcode;
